import pageInit from '@/router/page-init'
import store from '@/store/index'
import NProgress from 'nprogress'
import { checkMiniEnv, checkPromote } from '@/views/live-slice/utils'
import { saveChannelId } from '@/utils/channel'

export default async function beforeEach(to, from, next) {
  NProgress.start()
  store.dispatch('route/before', { to, from })
  store.dispatch('route/loadingBefore', true)
  await pageInit(to, next)
  saveChannelId(to.query)
  checkPromote(to)
  checkMiniEnv(to)
}
